
import { Component, Vue } from "vue-property-decorator";
import GeneralFooter from "@/components/general-footer.vue";
import { Action, Getter, Mutation } from "vuex-class";
import { SinglePagePayload } from "@/store/mutations";
import { FormValues } from "@/interfaces/FormValues";
import { FINISH_ORDER } from "@/router";
import { SubmissionPayload } from "@/store/actions";
import { PAGE_NAMES } from "@/constants/form-page-names";
import {
  CONTENT_FIELD_NAMES,
  RESOURCES_FIELD_NAMES,
} from "@/constants/form-field-names";
import { TYPE_OF_ORDER_VALUES } from "@/constants/shared-input-constants";

@Component({
  components: {
    GeneralFooter,
  },
})
export default class Daten extends Vue {
  public form_values: FormValues = {};

  @Action("submitAllFormValues")
  submitAllFormValues!: (payload: SubmissionPayload) => Promise<void>;

  @Getter("allFormValues")
  allFormValues!: Record<string, FormValues>;

  @Getter("userEmail")
  userEmail!: string;

  @Getter("bankName")
  bankName!: string;

  @Mutation("setFormValues")
  setFormValues!: (payload: SinglePagePayload) => void;

  FIELD_NAMES = RESOURCES_FIELD_NAMES;

  mounted() {
    // load from store or set default values
    this.form_values = this.allFormValues[PAGE_NAMES.assets] || {};
  }

  get isAlreadyExistingOrder(): boolean {
    if (
      this.allFormValues[PAGE_NAMES.content] &&
      this.allFormValues[PAGE_NAMES.content][CONTENT_FIELD_NAMES.typeOfOrder]
    ) {
      return (
        this.allFormValues[PAGE_NAMES.content][
          CONTENT_FIELD_NAMES.typeOfOrder
        ] === TYPE_OF_ORDER_VALUES.ALREADY_EXISTING_ORDER
      );
    }
    return false;
  }

  typeOfResourceValues = {
    NEW_RESOURCES: "Gelieferte Daten per Media Portal",
    ALREADY_EXISTING_RESOURCES: "Bestehendes Bildmaterial aus Media Library",
    NO_CHANGES: "Keine Änderung gewünscht (bestehender Spot)",
  };

  typeOfResource = this.typeOfResourceValues.NEW_RESOURCES;

  get typeOfResourcesRadioOptions() {
    if (this.isAlreadyExistingOrder) {
      return [
        {
          label: "Gelieferte Daten per Media Portal",
          value: this.typeOfResourceValues.NEW_RESOURCES,
        },
        {
          label: "Bestehendes Bildmaterial aus Media Library",
          value: this.typeOfResourceValues.ALREADY_EXISTING_RESOURCES,
        },
        // this option is only available when changing already existing spot
        {
          label: "Keine Änderung gewünscht (bestehender Spot)",
          value: this.typeOfResourceValues.NO_CHANGES,
        },
      ];
    } else {
      return [
        {
          label: "Gelieferte Daten per Media Portal",
          value: this.typeOfResourceValues.NEW_RESOURCES,
        },
        {
          label: "Bestehendes Bildmaterial aus Media Library",
          value: this.typeOfResourceValues.ALREADY_EXISTING_RESOURCES,
        },
      ];
    }
  }

  get myJLSLink(): string {
    return this.isExistingResource
      ? "https://my.jls.ch/content/content_eab73ca1-bd75-439f-8caa-7a0dc630f6de_c1f20c8d-ae31-45fb-96ac-a40ca73cc7a1"
      : "https://my.jls.ch/fileupload";
  }

  get myJLSLinkText(): string {
    return this.isExistingResource
      ? "geht es zur Media Library."
      : "geht es zum File Upload.";
  }

  get isNewResource(): boolean {
    return this.typeOfResource === this.typeOfResourceValues.NEW_RESOURCES;
  }

  get isExistingResource(): boolean {
    return (
      this.typeOfResource ===
      this.typeOfResourceValues.ALREADY_EXISTING_RESOURCES
    );
  }

  get isNoResourceRequired(): boolean {
    return this.typeOfResource === this.typeOfResourceValues.NO_CHANGES;
  }

  public prev(): void {
    this.$router.go(-1);
  }

  public next(): void {
    this.$router.push({ name: FINISH_ORDER });
  }

  public async submit(): Promise<void> {
    const payload = {
      PAGE_NAME: PAGE_NAMES.assets,
      formValues: this.form_values,
    };

    this.setFormValues(payload);
    this.next();
  }
}
